import { useFlag } from '@unleash/proxy-client-react';
import useLocalFlag from '../components/FeatureFlag';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';

export const GetFlag = (flag: string) => {
  const unleashFlag = useFlag(`${process.env?.REACT_APP_BASE_URL}_${flag}`);
  const email = useSelector((state: ApplicationState) => state.user.email);
  const localFlag = useLocalFlag(
    email,
    `${process.env?.REACT_APP_BASE_URL}_${flag}`
  );

  if (process.env.REACT_APP_USE_UNLEASH === 'true') {
    return unleashFlag;
  }

  return localFlag;
};
